import { getInterviewVars, getResults, InterviewUtils } from '../utils';
import { Box, useStyleConfig } from '@chakra-ui/react';
import Questions from './Questions';
import Results from './Results';
import React from 'react';

const SubSection = ({  props }) =>  {
  const iu = new InterviewUtils(props);

  const variant = 'wrapper';
  const styles = {};
  styles.interview = useStyleConfig('Interview', { variant });
  styles.button = useStyleConfig('Button', { variant });

  return iu.results.interview === null ? (
    <Questions iu={iu} styles={styles}/>
  ) : (
    <Results  iu={iu} styles={styles}   />
  );
}
export default SubSection;